import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { p } from "~/misc/common";

export default class extends Controller {
	connect() {
		console.log('initGroupReport2Show');
		$('.magicData').on('click', function () {
			const data = $(this).data();
			p(data);
			navigator.clipboard.writeText(JSON.stringify(data));
		});
	}
}
